import { getData } from "@/lib/utils";
import api from "@/store/api";

type ShippingAddress = {
  fullName: string;
  address: string;
  region: string;
  phoneNumber: string;
  city: string;
  isDefault: boolean;
};
export const useShipping = () => {
  const myShipping = async () => {
    try {
      const Token = getData("tokens")?.accessToken;
      const response = await api.get("/shipping-addresses", {
        headers: {
          Authorization: `Bearer ${Token}`,
        },
      });
      return response.data;
    } catch (err: any) {
      console.error(err);
    }
  };
  const createShipping = async (data: ShippingAddress) => {
    try {
      const Token = getData("tokens")?.accessToken;
      const response = await api.post("/shipping-addresses", data, {
        headers: {
          Authorization: `Bearer ${Token}`,
        },
      });
      return response.data;
    } catch (err: any) {
      console.error(err);
    }
  };
  const updateShipping = async (id: string, data: ShippingAddress) => {
    try {
      const Token = getData("tokens")?.accessToken;
      const response = await api.put(`/shipping-addresses/${id}`, data, {
        headers: {
          Authorization: `Bearer ${Token}`,
        },
      });
      return response.data;
    } catch (err: any) {
      console.error(err);
    }
  };
  const deleteShipping = async (id: string) => {
    try {
      const Token = getData("tokens")?.accessToken;
      const response = await api.delete(`/shipping-addresses/${id}`, {
        headers: {
          Authorization: `Bearer ${Token}`,
        },
      });
      return response.data;
    } catch (err: any) {
      console.error(err);
    }
  };
  const setDefaultShipping = async (id: string) => {
    try {
      const Token = getData("tokens")?.accessToken;
      const response = await api.put(
        `/shipping-addresses/${id}/set-default`,
        {},
        {
          headers: {
            Authorization: `Bearer ${Token}`,
          },
        }
      );
      return response.data;
    } catch (err: any) {
      console.error(err);
    }
  };
  return {
    myShipping,
    createShipping,
    updateShipping,
    deleteShipping,
    setDefaultShipping,
  };
};
